import pick from 'lodash/pick';

import { db, functions } from '.';

async function updateUserInDB(authUser, data = {}) {
  const currentUser = pick(authUser, ['uid', 'email', 'photoURL']);

  const user = await db
    .collection('users')
    .doc(authUser.uid)
    .set(
      {
        ...currentUser,
        ...data,
        lastSeen: new Date()
      },
      { merge: true }
    );

  return user;
}
async function getUserFromDB(id) {
  const ref = db.collection('users').doc(id);
  const snapshot = await ref.get();
  return {
    id,
    ...snapshot.data()
  };
}

async function updateUser(user) {
  const updateAuthUser = functions.httpsCallable('adminUsersUpdate');
  await updateAuthUser(user);
}

export default {
  get: getUserFromDB,
  update: updateUserInDB,
  updateUser: updateUser
};
